import React from 'react'
import { Button, CardGroup, Card} from 'react-bootstrap'

const Triceps = () => {
  return (

    <>
<br/>
<div className="d-grid gap-3">
      <Button style={{height:'70px'}} variant="secondary" size="lg"> Videos for train triceps</Button>
    </div>

    <CardGroup>
            <Card style={{margin:'25px'}}>
            <div>
                <video 
                    style={{objectFit:'center'}} 
                    width="100%" 
                    height="100%" 
                    // autoPlay="false" 
                    controls>
                    <source src="triceps1.mp4" type="video/mp4" />
                </video>
            </div>
                <Card.Title style={{textAlign:'center'}}>Triceps workout at home</Card.Title>
                {/* <Card.Text>
                In this video I take you 7 different bicep exercises you can do to get bigger arms! 
                These are CRUCIAL exercises to add to your arm day arsenal to grow your biceps.
                </Card.Text>  */}
            </Card>

            <Card style={{margin:'25px'}}>
            <div>
                <video 
                    style={{objectFit:'center'}} 
                    width="100%" 
                    height="100%"
                    // autoPlay="false" 
                    controls>
                    <source src="triceps2.mp4" type="video/mp4" />
                </video>
            </div>
            <Card.Title style={{textAlign:'center'}}>Triceps workout at gym</Card.Title>
            </Card>
    </CardGroup>


    <CardGroup>
            <Card style={{margin:'25px'}}>
            <div>
                <video 
                    style={{objectFit:'center'}} 
                    width="100%" 
                    height="100%" 
                    // autoPlay="false" 
                    controls>
                    <source src="triceps3.mp4" type="video/mp4" />
                </video>
            </div>
            <Card.Title style={{textAlign:'center'}}>Triceps workout with only dumbells</Card.Title>
            </Card>

            <Card style={{margin:'25px'}}>
            <div>
                <video 
                    style={{objectFit:'center'}} 
                    width="100%" 
                    height="100%" 
                    // autoPlay="false" 
                    controls>
                    <source src="triceps4.mp4" type="video/mp4" />
                </video>
            </div>
            <Card.Title style={{textAlign:'center'}}>Triceps workout, no bench needed</Card.Title>
            </Card>
    </CardGroup>

</>

  )
}

export default Triceps